import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import {Field, Formik} from "formik";
import TextField from "../../../components/Ui/TextField";
import Button from "react-bootstrap/Button";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import PasswordUpdatePage from "../../Account/PasswordUpdatePage/PasswordUpdatePage";
import {Link, Route, useRouteMatch, Switch, Redirect} from "react-router-dom";
import UserInfoUpdatePage from "../../Account/UserInfoUpdatePage/UserInfoUpdatePage";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        backgroundColor: 'white',
        borderRadius: 8
    },
    menuItem: {
        display: 'block',
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        paddingLeft: 25,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        '&.active': {
            background: theme.palette.primary.main,
            color: 'white',
        }
    },
}));


export default function UserInfo(props){

    const classes = useStyles();

    return (

        <>

            {
                useRouteMatch('/account') && (
                    <Redirect to={'/account/infos'} />
                )
            }

            <div className={`${classes.root} row no-gutters`}>

                <div className="col-lg-3 col-12 py-5 my-lg-15">

                    <Link to={'/account/infos'} className={clsx(
                        [
                            classes.menuItem,
                            {
                                'active': useRouteMatch('/account/infos')
                            }]
                    )}>
                        Informations personnelles
                    </Link>

                    <Link to={'/account/password'}  className={clsx(
                        [
                            classes.menuItem,
                            {
                                'active': useRouteMatch('/account/password')
                            }]
                    )}>
                        Mot de passe
                    </Link>

                </div>

                <div className={'col-auto'}>
                    <div style={{height: '100%',width: 1,background:'black'}}></div>
                </div>

                <div className="col-lg col-12 px-5 position-relative py-5 my-lg-10">

                    <Switch>

                        <Route exact={true}  path={'/account/password'} component={PasswordUpdatePage} />
                        <Route exact={true}  path={'/account/infos'} component={UserInfoUpdatePage} />

                    </Switch>


                </div>

            </div>

        </>

    );
}